import GuildMessageTile from './GuildMessageTile'
import TeamDescriptionTile from './TeamDescriptionTile'
import CustomLinksTile from './CustomLinksTile'
import CustomImageTile from './CustomImageTile'
import RecentNewsTile from './RecentNewsTile'
import OverviewTableTile from './OverviewTableTile'
import SidebarTilesTile from './SidebarTilesTile'
import RosterSummaryTile from './RosterSummaryTile'
import UpcomingEventsTile from './UpcomingEventsTile'
import RecentEventsTile from './RecentEventsTile'
import EnchantAuditTile from './EnchantAuditTile'
import PendingApplicantsTile from './PendingApplicantsTile'
import RaidProgressTile from './RaidProgressTile'
import CustomTextTile from './CustomTextTile'

export const TileComponents = {
  GuildMessageTile,
  TeamDescriptionTile,
  CustomLinksTile,
  CustomImageTile,
  CustomTextTile,
  RecentNewsTile,
  OverviewTableTile,
  SidebarTilesTile,
  RosterSummaryTile,
  UpcomingEventsTile,
  RecentEventsTile,
  EnchantAuditTile,
  PendingApplicantsTile,
  RaidProgressTile,
}
